import React from "react";
import { Card, CardContent, Typography, Box, Avatar } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import { useTheme } from "@emotion/react";
import useStyles from "./styles";
const StyledCard = styled(Card)(({ theme, gradient }) => ({
  height: "100%",
  borderRadius: "16px",
  background: gradient || theme.palette.background.paper,
}));

const MetricCard = ({ title, value = 0, subtitle, icon, iconColor = "" }) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const colors = [
    theme.palette.colors.red.medium,
    theme.palette.colors.orange.medium,
    theme.palette.colors.purple.medium,
    theme.palette.colors.blue.medium,
    theme.palette.colors.green.medium,
  ];

  const colorCard =
    value >= 4.5
      ? colors[4]
      : value < 4.5 && value >= 4
      ? colors[3]
      : value >= 3 && value < 4
      ? colors[2]
      : value >= 2 && value < 3
      ? colors[1]
      : colors[0];
  return (
    <StyledCard sx={{ transform: "scale(0.8)" }} gradient={colorCard}>
      <CardContent sx={styles.containerCard}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {icon && (
            <Avatar
              sx={{
                ...styles.containerAvatar,
                bgcolor: alpha(iconColor, 0.2),
                color: iconColor,
              }}
            >
              {icon}
            </Avatar>
          )}
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="body2"
              sx={{
                ...styles.colorTitle,
                color: theme.palette.white.main,
              }}
            >
              {title}
            </Typography>
          </Box>
        </Box>

        <Box sx={styles.boxContainer}>
          <Typography
            variant="h3"
            sx={{
              ...styles.value,
              color: theme.palette.white.main,
            }}
          >
            {value}
          </Typography>

          {subtitle && (
            <Typography
              variant="body2"
              sx={{
                color: theme.palette.white.main,
                fontSize: "0.875rem",
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default MetricCard;
